/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
/** @jsxImportSource solid-js */

import { customElement, noShadowDOM } from 'solid-element';
import Empty, { EmptyProps } from './Empty';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-empty': Partial<HTMLElement> & EmptyProps & Partial<{ ref: any }>;
    }
  }
}

export function defineSolidEmpty(): void {
  customElement(
    'tc-empty',
    {
      // Include ALL component properties with default values here
      // This is CRITICAL for proper property synchronization
      title: undefined,
      message: '',
      icon: '',
      content: undefined,
      isSmallContainer: false,
      class: '',
      backgroundTopColor: undefined,
      backgroundBottomColor: undefined,
    },
    (props) => {
      noShadowDOM();
      return <Empty {...props} />;
    }
  );
}
